<template>
    <div class="edit-profile">
        <div class="box">
            <Advertisement/>
        </div>
        <div class="box">
        <div class="edits">
            <SystemNotification v-if="message != null" :message="message"/>
            <div class="heading2-section">
                Email Verification
            </div>

        <div class="verification-message">
            An email containing a verification link has been sent to <span style="color:var(--page-header);">{{ signupEmail }}</span>. If the email has not reached you, click the resend button.
        </div>
       
         <div class="form-buttons mb-3">


                <button @click="resendLink()" :disabled="loading" class="btn btn-default primary-btn">{{ loading ? 'Resending Link...':'Resend Verification Link'}}</button>
            </div>
          <!-- errors -->
        <div class="errors" v-if="hasErrors">
            <div class="error" v-for="error in errors">{{ error }}</div>
        </div>
        <!-- errors -->     
       
        <div class="bottom-links">
        
        <router-link style="text-decoration:none;color:var(--sidenav-link-active);font-weight: bold;" to="/login">Go To Login</router-link>
        </div>
        <LoadingIndicator v-if="loading"/>
        </div>
        </div>
    </div>
    <ConfirmationMessageModal :title="modal.caption" :body="modal.message" button-label="Close" :close-modal="() => closeModal()"/>
</template>
<script>
import { resentVerificationLinkAsync } from '@/services/authService';
import LoadingIndicator from '@/components/Utility/LoadingIndicator.vue';
import ConfirmationMessageModal from '@/components/modals/ConfirmationMessageModal.vue';
import Modal from 'bootstrap/js/dist/modal'
import Advertisement from '../shared/Advertisement.vue';
import SystemNotification from '@/components/Utility/SystemNotification.vue';

export default {
    components:{
        LoadingIndicator,
        ConfirmationMessageModal, Advertisement, SystemNotification
    },
    data(){
        return{
            url: process.env.VUE_APP_API_URL,
           
            modal:{
                caption:"",
                message:""
            },
            confirmModal: null,
            errors:[],
            loading:false,
            hasErrors:false,
            message: this.$route.query.message,
            signupEmail:""
        }
    },
    created(){
         let email = sessionStorage.getItem('signup-email');
         if(email == null){
            this.$router.push("/signup");
            return;
         }
         this.signupEmail = email;
    },
      mounted(){
        this.confirmModal = new Modal(document.getElementById('confirmMessageModal'))
        // this.$refs.loginContainer.scrollIntoView({ behavior: 'smooth', block: 'start' });
        window.scrollTo({top: 0,behavior: 'smooth'});
    },
     methods:{
     async resendLink(){
        try{
            this.resetOnNewSubmit();
            var data = await resentVerificationLinkAsync({
                    email: this.signupEmail
                });
            this.loading = false;
            if(data.success){
                if(data.isSent){
                    this.message = "Your Email Verification Link has been sent";
                    setTimeout(() => this.message = null, 5000);
                }
            }else{
                if(data.errors){
                    data.errors.forEach((err) => {
                        this.errors.push(err);
                    });
                    this.hasErrors = true;
                    setTimeout(() => {
                                this.errors = [];
                                this.hasErrors = false;
                            }, 5000);
                    return;
                }
                throw new Error(data.message, {cause: data.caption})
            }
        
        }catch(e){
            this.loading = false;
            let message = e.message || "Something went wrong. Please try again";
            this.errors.push(message);
            this.hasErrors = true;
            setTimeout(() => {
                this.errors = [];
                this.hasErrors = false;
            }, 5000);
            
        }     
    },
    resetOnNewSubmit(){
            this.loading = true;
            this.hasErrors = false;
            this.errors = [];
    },
    closeModal(){
      this.confirmModal.hide();
    },
    showModal(){
        this.confirmModal.show();
    }
   }
}
</script>
<style scoped>

.primary-btn{
    width:100%;
}

.edit-profile{
    display: grid;
    grid-template-columns: 1.5fr 1fr;
    margin-top:1.4rem;
}

.box:last-child{
    overflow-y: auto;
    max-height:80vh;
}

.edits{
    grid-column:2/3;
    padding:0rem 5rem;
}

    .select-dates, .select-date{
    display: flex;
    
}

.select-date{
    column-gap:0.5rem;
}

.select-dates{
    row-gap:0.8rem;
    align-items: flex-start;
    flex-direction: column;
}



input{
    border:0px!important;
}

.bottom-links{
    display: grid;
    grid-template-rows:auto auto;
}

.bottom-link-mobile{
    display: none;
}


@media (max-width:768px) {
    .edits{
    grid-column:1/4;
    margin:0rem 0.8rem;
    padding:0rem 0.1rem;
}

.box:first-child{
    display: none;
}

.edit-profile{ 
    margin:1rem 0rem;

    grid-template-columns: auto ;
}

.bottom-link-mobile{
    display: block;
}
}
</style>